<template>
  <div class="text-center" v-if="contactItem">
    <h1>
      <router-link :to="'/events/'+ eventItem.id">
        <i class="fas fa-long-arrow-alt-right"></i> {{ eventItem.title }}
      </router-link>
    </h1>
    <div class="container-fluid container-lg">
    
      <ContactImage :contactItem="contactItem" :publicPath="publicPath" />
      
      <h2>{{ contactItem.name }} {{ contactItem.surname }}</h2>
      
      <ContactInfo :contactItem="contactItem" />
      
      <hr>
      
      <div v-if="contactItem.checkinFair">
        <h3>Presence at fair:</h3>
        <p>
          <span class="font-bold">From:</span> {{ contactItem.checkinFair }}<br> 
          <span class="font-bold">To:</span> {{ contactItem.checkoutFair }}
        </p>
      </div>
      
    </div>
  </div>
</template>

<script>
import ContactImage from '../contacts/ContactImage';
import ContactInfo from '../contacts/ContactInfo';

export default {
  name: 'ContactPage',
  props: ['contactid', 'id', 'subpage'],
  data () {
    return {
      publicPath: process.env.BASE_URL,
      ispresent: false
    }
  },
  computed: {
    eventItem () {
      return this.$store.getters.fairItemFromId(Number(this.id));
    },
    contactItem () {
      let contact = this.$store.getters.contactItemFromId(Number(this.contactid));
      if (!contact) return null;
      if (!this.subpage) return contact;
      let participant;
      if (this.subpage === 'staff' && contact.staff) {
        participant = contact.staff.find(userItem => userItem.fairId === Number(this.id))
      }
      if (this.subpage === 'participants' && contact.participants) {
        participant = contact.participants.find(userItem => userItem.fairId === Number(this.id))
      }
      if (participant && participant.checkinFair) {
        contact.checkinFair = global.formatDate(participant.checkinFair)
        contact.checkoutFair = global.formatDate(participant.checkoutFair)
        if (this.subpage === 'staff') {
          contact.unit = participant.unit
          contact.role = participant.role
        }
      }
      return contact;
    },
  },
  components: {
    ContactImage,
    ContactInfo
  }
}
</script>

<style>
</style>

<style scoped>
</style>
